module.exports = __webpack_public_path__ + "img/stopper.b73962ee.jpg";